import { useState, useCallback, useMemo } from "react";
import type { Card } from "../data/types";

export function useCardSheet(allCards: Card[]) {
  const [selectedCardId, setSelectedCardId] = useState<string | null>(null);

  const selectedCard = useMemo(
    () => (selectedCardId ? allCards.find((c) => c.id === selectedCardId) ?? null : null),
    [selectedCardId, allCards],
  );

  const isOpen = selectedCard !== null;

  const openCard = useCallback((cardId: string) => {
    setSelectedCardId(cardId);
  }, []);

  const close = useCallback(() => {
    setSelectedCardId(null);
  }, []);

  return { selectedCardId, selectedCard, isOpen, openCard, close };
}
